import type { FeatureGroup } from '@/features/Features';
import { useFeaturesStore } from '@/features/Features';
import { usePhvInputStore } from '@/features/Sparten/phv/useInputStore';
import cloneDeep from 'lodash/cloneDeep';
import type {
  PhvFeatureMetaType,
  RelevantInputFields,
} from '@/features/Sparten/phv/utils/types';

export const featureFilterFunction = (): FeatureGroup<PhvFeatureMetaType>[] => {
  const { diensthaftpflicht } = usePhvInputStore();
  const relevantInputFields: RelevantInputFields = {
    diensthaftpflicht,
  };

  const clonedFeatures: FeatureGroup<PhvFeatureMetaType>[] = cloneDeep(
    useFeaturesStore().data,
  ) as FeatureGroup<PhvFeatureMetaType>[];

  clonedFeatures.forEach((group, index) => {
    clonedFeatures[index].items = group.items.filter((feature) => {
      const visibleIn = feature.meta?.visible ?? [];

      if (visibleIn.length > 0) {
        let visible = false;
        feature.meta?.visible.forEach((field) => {
          visible = relevantInputFields[field as keyof RelevantInputFields];
        });

        return visible;
      }

      return true;
    });
  });

  return clonedFeatures;
};
